/**
 * Created by tomers on 2/26/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var BaseModel = require("models/BaseModel");
    var IntegrationsEnum = require("manager-assets/data/data-sources/integrations/IntegrationsEnum.json");
    var IntegrationsAttributesCollection = require("manager-collections/data-sources/integrations/IntegrationsAttributesCollection");

    var KEYS = {
        ID: "id",
        NAME: "name",
        SHOW: "show",
        BUTTON_NAME: "buttonName",
        HAS_CONNECTION_STATUS: "hasConnectionStatus",
        CONNECTIONS: "connections",
        ROUTE_BUTTON_CLICK: "routeBtnClick",
        SLUG_ID: "slugId",
        SLUG_CAPTION: "slugCaption",
        HAS_KP_WITH_DESCRIPTION: "hasKPWithDescription",
        DESCR_SLUG_ID: "descrSlugId",
        DESCR_SLUG_CAPTION: "descrSlugCaption",
        ACTION_TYPE: "actionType",
        ATTRIBUTES: "attributes",
        CONNECTOR_CONFIG: "config", //url coming from google API
        METRIC_NAME: "metricName"
    };

    var CONNECTION_STATUS = {
        UNKNOWN: "unknown",
        NONE: "none",
        PARTIAL: "partial",
        FULLY: "fully"
    };

    var ACTION_TYPE = {
        ROUTE: "route",
        CONNECT: "connect",
        KP: "kp"
    };

    var CONST = {
        "MAX_ITEMS_PER_COLUMN": 5
    };

    var LEAD_ID = 4;

    var IntegrationsRowsModel = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {

        IntegrationsRowsModel = BaseModel.extend({
            CONNECTION_STATUS: CONNECTION_STATUS,
            defaults : {
                "id": null,
                "name": "",
                "show": false,
                "buttonName": "",
                "hasConnectionStatus": false,
                "connections": -1,
                "routeBtnClick": "",
                "slugId": "",
                "slugCaption": "",
                "hasKPWithDescription": false,
                "descrSlugId": "",
                "descrSlugCaption": "",
                "actionType": "actionType",
                "metricName": "",
                "attributes": []
            },
            name: "IntegrationsRowsModel",

            initialize: function(options){
            },

            getId: function(){
                return this.get(KEYS.ID);
            },
            getShow: function(){
                return this.get(KEYS.SHOW);
            },
            setShow: function(show){
                this.set(KEYS.SHOW, show);
            },
            getLogicalName: function(){
                return this.get(KEYS.NAME);
            },
            getName: function(){
                return LE.translator.translate("LEManager.dataSources.tab.integrations.row." + this.getLogicalName() + ".title");
            },
            getDescription: function(){
                return LE.translator.translate("LEManager.dataSources.tab.integrations.row." + this.getLogicalName() + ".description");
            },
            getLogicalButtonName: function(){
                return this.get(KEYS.BUTTON_NAME);
            },
            getButtonName: function(){
                return LE.translator.translate("LEManager.dataSources.tab.integrations.button." + this.getLogicalButtonName() + ".label");
            },
            hasConnectionStatus: function(){
                return this.get(KEYS.HAS_CONNECTION_STATUS);
            },
            getConnections: function(){
                return this.get(KEYS.CONNECTIONS);
            },
            getMetricName: function(){
                return this.get(KEYS.METRIC_NAME);
            },
            setConnections: function(connections){
                this.set(KEYS.CONNECTIONS, connections);
            },
            isConnected: function(){
                return this.hasConnectionStatus() && this.getConnections() > 0;
            },
            isMetricTypeConnection: function(){
                return this.hasConnectionStatus() && !_.isEmpty(this.getMetricName());
            },
            getConnectionStatus: function(){
                if (!this.isConnected() && this.getConnections() === -1){
                    return CONNECTION_STATUS.UNKNOWN;
                }
                else {
                    return (this.getConnections() === 0) ? CONNECTION_STATUS.NONE : CONNECTION_STATUS.FULLY;
                }
            },
            getConnectionStatusName: function(){
                var connected = this.getConnectionStatus();
                return connected === CONNECTION_STATUS.UNKNOWN ? "" : LE.translator.translate("LEManager.dataSources.tab.integrations.status." + connected.toString() + ".label");
            },
            getActionType: function(){
                return this.get(KEYS.ACTION_TYPE);
            },
            isGoogleAnalytics: function(){
                return (this.isConnectActionType() && this.getId() === IntegrationsEnum.ROWS.WEB_ANALYTICS);
            },
            isLiveEngageTag: function(){
                return (this.isConnectActionType() && this.getId() === IntegrationsEnum.ROWS.LPTAG);
            },
            isAuthentication: function(){
                return (this.getId() === IntegrationsEnum.ROWS.AUTHENTICATION_SERVER);
            },
            isEditEnabled: function(){
                var result = true;
                if (this.isAuthentication() && !LE.sessionManager.hasPrivilege(LE.sessionManager.PRIVILEGES.VIEW_AC_INTEGRATIONS_CONNECTORS)){
                    result = false;
                }
                return result;
            },
            isConnectActionType: function(){
                return this.getActionType() === ACTION_TYPE.CONNECT;
            },
            getRouteButtonClick: function(){
                return this.get(KEYS.ROUTE_BUTTON_CLICK);
            },
            getSlugId: function(){
                return this.get(KEYS.SLUG_ID);
            },
            getSlugCaption: function(){
                return LE.translator.translate("LEFramework.global.captions.learnMore");
            },
            hasKPWithDescription: function(){
                return this.get(KEYS.HAS_KP_WITH_DESCRIPTION);
            },
            getDescrSlugId: function(){
                return this.get(KEYS.DESCR_SLUG_ID);
            },
            getDescrSlugCaption: function(){
                return LE.translator.translate("LEFramework.global.captions.learnMore");
            },
            getConnectorConfig: function () {
                return this.get(KEYS.CONNECTOR_CONFIG);
            },
            setConnectorConfig: function (config) {
                this.set(KEYS.CONNECTOR_CONFIG, config, {silent: true});
            },
            getEngagementAttributes: function () {
                var attributes = this.get(KEYS.ATTRIBUTES);
                if (LE.siteSettings.accountSettings.isAutomotive()) {
                    attributes = _.reject(attributes, { id: LEAD_ID });
                }
                return attributes;
            },
            hasEngagementAttributes: function(){
                var attributes = this.getEngagementAttributes();
                return !_.isUndefined(attributes) && attributes.length > 0;
            },
            getAttributesCollection: function(fromIndex, toIndex){
                if (!this.hasEngagementAttributes()){
                    return null;
                }
                var array = this.getEngagementAttributes();
                if (_.isUndefined(this.attributesCollection)) {
                    this.attributesCollection = new IntegrationsAttributesCollection(array);
                }

                return this.attributesCollection;
            },
            getLeftAttributesCollection: function(){
                if (!this.hasEngagementAttributes()){
                    return null;
                }
                if (_.isUndefined(this.leftAttributesCollection)) {
                    var maxItemsPerColumn = CONST.MAX_ITEMS_PER_COLUMN;
                    var array = this.getEngagementAttributes();
                    array = array.slice(0, maxItemsPerColumn);
                    this.leftAttributesCollection = new IntegrationsAttributesCollection(array);
                }
                return this.leftAttributesCollection;
            },
            getRightAttributesCollection: function(){
                if (!this.hasEngagementAttributes()){
                    return null;
                }
                if (_.isUndefined(this.rightAttributesCollection)) {
                    var maxItemsPerColumn = CONST.MAX_ITEMS_PER_COLUMN;
                    var array = this.getEngagementAttributes();
                    if (maxItemsPerColumn > this.getAttributesCollection().size())
                    {
                        this.rightAttributesCollection = new IntegrationsAttributesCollection();
                    }
                    else {
                        array = array.slice(maxItemsPerColumn, (2 * maxItemsPerColumn));
                        this.rightAttributesCollection = new IntegrationsAttributesCollection(array);
                    }
                }
                return this.rightAttributesCollection;
            },
            getAttributeById: function(attributeId){
                if (!this.hasEngagementAttributes()){
                    return null;
                }
                var attributesCollection = this.getAttributesCollection();
                var attributesModel = attributesCollection.get(attributeId);
                return attributesModel;
            },
            getAttributesMetricsNames: function(){
                var result = [];
                if (!this.hasEngagementAttributes()){
                    return result;
                }
                var attributesCollection = this.getAttributesCollection();
                _.each(attributesCollection.models, function(model){
                    result.push(model.getMetricName());
                });
                return result;
            },
            updateMetricsConection: function(metricsData){
                if (!this.hasEngagementAttributes()){
                    return;
                }
                var metric = null;
                var attributesCollection = this.getAttributesCollection();
                _.each(attributesCollection.models, function(model){
                    metric = _.filter(metricsData, function(obj){
                        return obj.metricType === model.getMetricName();
                    });
                    //model.setConnections(5);
                    model.setConnections(metric.length === 0 ? 0 : metric[0].counter);
                });
            },
            arePropertiesBlank: function(agent){
                if (!this.hasEngagementAttributes()){
                    return false;
                }
                return this.getAttributesCollection().areAllPropertiesBlank(agent);
            },
            arePropertiesValid: function(){
                if (!this.hasEngagementAttributes()){
                    return false;
                }
                return this.getAttributesCollection().areAllPropertiesValid();
            },
            getUnsavedAttributesData: function () {
                var result = [];
                if (!this.hasEngagementAttributes()) {
                    return result;
                }
                return this.getAttributesCollection().getUnsavedAttributesData();
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    IntegrationsRowsModel.KEYS = KEYS;
    IntegrationsRowsModel.CONNECTION_STATUS = CONNECTION_STATUS;
    IntegrationsRowsModel.ACTION_TYPE = ACTION_TYPE;

    return IntegrationsRowsModel;
});
